// import React from "react";
// import backArrow from "../../../assets/icons/Back.svg";
// import { useNavigate, useParams } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import bettingService from "../../../api/services/bettingService";
// import { useState } from "react";
// import { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { playSong } from "../../common/actions/common.actions";
// import { IoIosArrowBack } from "react-icons/io";
// import Logo from "../../../assets/newIcons/Lucky.png";

// const OldMatchesPage = ({ setIsLoading }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { oldHistory } = useSelector((state) => state.sidebar);
//   const { id } = useParams();
//   const { t } = useTranslation();
//   const [oldMatches, setOldMatches] = useState([]);
//   const language = localStorage.getItem("language");
//   const profitAmount = oldHistory
//     ? oldHistory?.profitAmount >= 0
//       ? oldHistory.profitAmount
//       : 0
//     : 0;
//   const winAmount = Math.max(profitAmount - (oldHistory?.amount || 0), 0);

//   const handleBackClick = async () => {
//     dispatch(playSong());
//     navigate("/old-histories");
//   };

//   useEffect(() => {
//     setIsLoading(true);
//     bettingService
//       .bettingHistoryDetails({
//         gamblingId: Number(id),
//         status: "Finished",
//       })
//       .then((response) => response.json())
//       .then((data) => {
//         if (data) {
//           const sortedData = data.slice().sort((a, b) => {
//             const dateA = new Date(
//               a.eventDate.split(" ")[0].split("-").reverse().join("-") +
//                 " " +
//                 a.eventDate.split(" ")[1]
//             );
//             const dateB = new Date(
//               b.eventDate.split(" ")[0].split("-").reverse().join("-") +
//                 " " +
//                 b.eventDate.split(" ")[1]
//             );
//             return dateA - dateB;
//           });
//           setOldMatches(sortedData);
//         }
//         setIsLoading(false);
//       })
//       .catch((err) => {
//         setIsLoading(false);
//         console.error("API request error:", err);
//       });
//   }, [id, navigate, setIsLoading]);

//   return (
//     <div className="w-full h-screen flex flex-col  overflow-hidden">
//       <div className="flex justify-start items-center py-2 bg-[#1f2937]">
//         <button
//           className="top-3 left-5 w-10 h-10
//                     rounded-full drop-shadow-lg flex justify-center items-center text-white text-4xl"
//           onClick={handleBackClick}
//         >
//           {/* <img src={backArrow} alt="Back Arrow" /> */}
//           <IoIosArrowBack size={25} color="white" />
//         </button>
//         <div className="flex-1 justify-center items-center">
//           <h3 className="text-white font-bold font-myanmarSansPro mr-7 text-start ml-2 dark:text-whitev1">
//             {t("oldMatches")}
//           </h3>
//         </div>
//       </div>
//       <div className="text-primary dark:text-league_text text-end text-sm mr-3 mt-2 font-dangrek">
//         BetID : {oldHistory?.postingNo}
//       </div>
//       <div className="flex-1 p-2 overflow-auto font-bold font-myanmarSansPro">
//         {oldMatches.map((match, index) => {
//           const bettedTeam =
//             language === "en" ? match?.bettedTeam : match?.bettedTeamMyan;
//           const oppositeTeamName =
//             language === "en"
//               ? match?.oppositeTeamName
//               : match?.oppositeTeamNameMyan;
//           return (
//             <div
//               key={index}
//               className="flex flex-col py-2 px-2 mb-2 rounded-md bg-gray-200"
//             >
//               <div className="flex justify-between items-center mb-1  text-xs sm:text-sm md:text-base text-k_leagueFgColor dark:text-white">
//                 <p className="text-left rounded-lg font-normal text-waterThree dark:text-black font-dangrek">
//                   {match?.eventDate}
//                 </p>
//               </div>
//               <div className="grid grid-cols-9 gap-1 mb-1">
//                 <div
//                   className={`${
//                     match?.home === true
//                       ? "bg-blue-500 border-2 border-gray-400 text-gray-200"
//                       : "border-2 border-gray-400 "
//                   } py-[8px] px-1 flex items-center col-span-4`}
//                 >
//                   <h3
//                     className={`ml-auto font-bold text-center  text-sm ${
//                       match?.home === true ? "" : ""
//                     } sm:text-base md:text-base ${
//                       match?.isHomeBodyOdd === false
//                         ? "flex flex-1 items-center justify-center"
//                         : "flex flex-1 justify-center"
//                     }`}
//                   >
//                     {match.isHome ? bettedTeam : oppositeTeamName}
//                   </h3>
//                   {match.isHomeBodyOdd === true && (
//                     <h3 className="bg-waterFour p-1 rounded-full text-wback font-bold text-xxs text-xs sm:text-sm md:text-base whitespace-nowrap">
//                       {match?.bodyOdd}
//                     </h3>
//                   )}
//                 </div>
//                 {/* <div className="flex flex-row justify-center gap-[1px]">
//                                     <div className="cursor-not-allowed text-center w-[20px] bg-red-600 rounded-md p-[3px] flex justify-center items-center ">
//                                         <h3 className="font-semibold text-center text-[#fff] text-base sm:text-sm md:text-base">
//                                             {match?.homeResult}
//                                         </h3>
//                                     </div>
//                                     <div className="cursor-not-allowed text-center w-[20px] bg-red-600 rounded-md p-[3px] flex justify-center items-center ">
//                                         <h3 className="font-semibold text-center text-[#fff] text-base sm:text-sm md:text-base">
//                                             {match?.awayResult}
//                                         </h3>
//                                     </div>
//                                 </div> */}
//                 <div className="flex justify-center items-center  text-center font-bold w-full rounded-full text-waterFour text-lg">
//                   {`${match?.homeResult}-${match?.awayResult}`}
//                 </div>
//                 <div
//                   className={`${
//                     match?.away === true
//                       ? "bg-blue-500 border-2 border-gray-400  text-gray-200"
//                       : "border-2 border-gray-400 "
//                   } py-[8px] px-1 flex justify-center items-center col-span-4`}
//                 >
//                   {match?.isHomeBodyOdd === false && (
//                     <h3 className="bg-waterFour text-wback price p-1 font-bold rounded-full text-xxs text-xs sm:text-sm md:text-base">
//                       {match?.bodyOdd}
//                     </h3>
//                   )}
//                   <h3
//                     className={` flex flex-1 w-full justify-center text-center dark:text-white text-sm sm:text-base md:text-base ${
//                       match?.isHomeBodyOdd === true &&
//                       "flex flex-1 justify-center items-center"
//                     }`}
//                   >
//                     {!match.isHome ? bettedTeam : oppositeTeamName}
//                   </h3>
//                 </div>
//               </div>
//               <div className="grid grid-cols-5 gap-1">
//                 <div
//                   className={`${
//                     match?.overs === true
//                       ? "bg-blue-500 border-2 border-gray-400  text-gray-200"
//                       : "border-2 border-gray-400 "
//                   }   col-span-2`}
//                 >
//                   <h3 className="text-center   text-sm sm:text-sm md:text-base py-2">
//                     {t("goalOver")}
//                   </h3>
//                 </div>
//                 <div className="cursor-not-allowed text-center border-2 border-gray-400 p-1 flex justify-center items-center">
//                   <h3 className="font-bold text-center text-white text-xs bg-waterFour p-1 rounded-full  sm:text-sm md:text-base">
//                     {match?.goalOdd}
//                   </h3>
//                 </div>
//                 <div
//                   className={`${
//                     match?.under === true
//                       ? "bg-blue-500 border-2 border-gray-400  text-gray-200"
//                       : "border-2 border-gray-400 "
//                   } col-span-2 flex justify-center items-center`}
//                 >
//                   <h3 className="text-center text-sm sm:text-sm md:text-base">
//                     {t("goalUnder")}
//                   </h3>
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//       <div className="w-full bg-[#1f2937] h-max flex flex-col justify-center items-center  py-3">
//         <div className="flex justify-start items-center w-full pl-5">
//           <h4 className=" text-white font-bold py-1 ">{t("betAmount")} :
//             {""} {oldHistory?.amount}
//           </h4>
//           {/* <h4 className=" text-black font-bold py-1">{oldHistory?.amount}</h4> */}
//         </div>
//         <div className="flex justify-between items-center w-full ">
//           <div className="flex items-center ml-5 ">
//             <h4 className=" text-white font-bold py-1 ">
//               {t("profitAmount")} :{" "}
//               {profitAmount}
//             </h4>
//             {/* <h4 className=" text-black font-bold py-1">{profitAmount}</h4> */}
//           </div>
//           <div className="flex  items-center mr-5">
//             <h4 className=" text-green-600 font-bold py-1 ">
//               {t("winAmount")} : {""}
//               {winAmount}
//             </h4>
//             {/* <h4 className=" text-green-600 font-bold py-1">{" "}{winAmount}</h4> */}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OldMatchesPage;

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { IoIosArrowBack } from "react-icons/io";
import bettingService from "../../../api/services/bettingService";
import { playSong } from "../../common/actions/common.actions";
// import Vs from "./Vs";

const OldMatchesPage = ({ setIsLoading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  const { oldHistory } = useSelector((state) => state.sidebar);
  const [oldMatches, setOldMatches] = useState([]);

  console.log("Old History:", oldMatches);

  const language = localStorage.getItem("language");
  const profitAmount =
    oldHistory?.profitAmount >= 0 ? oldHistory.profitAmount : 0;
  const winAmount = Math.max(profitAmount - (oldHistory?.amount || 0), 0);

  const handleBackClick = () => {
    dispatch(playSong());
    navigate("/old-histories");
  };

  useEffect(() => {
    setIsLoading(true);
    bettingService
      .bettingHistoryDetails({ gamblingId: Number(id), status: "Finished" })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          const sortedData = data.slice().sort((a, b) => {
            const dateA = new Date(
              a.eventDate.split(" ")[0].split("-").reverse().join("-") +
                " " +
                a.eventDate.split(" ")[1]
            );
            const dateB = new Date(
              b.eventDate.split(" ")[0].split("-").reverse().join("-") +
                " " +
                b.eventDate.split(" ")[1]
            );
            return dateA - dateB;
          });
          setOldMatches(sortedData);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.error("API error:", err);
      });
  }, [id, setIsLoading]);

  return (
    <div className="w-full h-screen flex flex-col bg-gradient-to-br from-[#EAEAEA] via-green-50 to-[#228B22]/10 relative font-myanmarSansPro">

      {/* Header */}
      <div className="relative z-10 bg-gradient-to-r from-[#228B22] via-emerald-600 to-[#1F5F1F] py-4 px-4 shadow-sm">
        <div className="flex items-center">
          <button
            className="w-10 h-10 mr-4 flex justify-center items-center text-white rounded-xl active:bg-white/20"
            onClick={handleBackClick}
          >
            <IoIosArrowBack size={25} />
          </button>
          <div>
            <h3 className="text-white font-bold text-xl">{t("oldMatches")}</h3>
            <p className="text-emerald-100 text-xs font-medium">Match Results</p>
          </div>
        </div>
      </div>

      {/* Bet ID */}
      <div className="relative z-10 px-4 py-2">
        <div className="bg-white/80 rounded-2xl px-4 py-3 border border-[#228B22]/20 shadow-sm">
          <div className="flex items-center justify-between">
            <span className="text-gray-700 font-semibold flex items-center">
              <span className="w-2 h-2 bg-[#228B22] rounded-full mr-2"></span>
              Bet ID:
            </span>
            <span className="font-dangrek font-bold text-[#228B22] text-lg">
              {oldHistory?.postingNo}
            </span>
          </div>
        </div>
      </div>

      {/* Match Results */}
      <div className="relative z-10 flex-1 overflow-auto px-4 pb-1">
        <div className="space-y-1">
          {oldMatches.map((match, index) => {
            const teamName =
              language === "en" ? match?.bettedTeam : match?.bettedTeamMyan;
            const oppTeam =
              language === "en"
                ? match?.oppositeTeamName
                : match?.oppositeTeamNameMyan;

            const isHome = match.isHome;
            const bodyOdd = match.bodyOdd;

            const displayGame = match.isHome ? (
              <>
                {/* Home Team */}
                <div className="flex items-center justify-between mb-1 w-full bg-white/70 rounded-xl px-3 py-1.5 border border-[#228B22]/10">
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-[#228B22] rounded-full mr-3"></div>
                    <div>
                      <span className="font-bold text-gray-800">{teamName}</span>
                      <span className="text-[#FF4500] font-bold ml-2">
                        {match.isHomeBodyOdd &&
                          !match.overs &&
                          !match.under &&
                          `(${bodyOdd})`}
                        {match.overs && ` Gp(${match.goalOdd})`}
                      </span>
                    </div>
                  </div>
                  <div className="bg-[#228B22] text-white px-3 py-0.5 rounded-lg font-bold">
                    {match?.homeResult}
                  </div>
                </div>

                {/* Away Team */}
                <div className="flex items-center justify-between w-full bg-white/70 rounded-xl px-3 py-1.5 border border-[#228B22]/10">
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-[#FFD700] rounded-full mr-3"></div>
                    <div>
                      <span className="font-bold text-gray-800">{oppTeam}</span>
                      <span className="text-[#FF4500] font-bold ml-2">
                        {!match.isHomeBodyOdd &&
                          !match.overs &&
                          !match.under &&
                          `(${bodyOdd})`}
                        {match.under && `Gp(${match.goalOdd})`}
                      </span>
                    </div>
                  </div>
                  <div className="bg-[#FFD700] text-gray-900 px-3 py-0.5 rounded-lg font-bold">
                    {match?.awayResult}
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* Home Team (Opponent) */}
                <div className="flex items-center justify-between mb-2 w-full bg-white/70 rounded-xl p-3 border border-[#228B22]/10">
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-[#FFD700] rounded-full mr-3"></div>
                    <div>
                      <span className="font-bold text-gray-800">{oppTeam}</span>
                      <span className="text-[#FF4500] font-bold ml-2">
                        {match.isHomeBodyOdd &&
                          !match.overs &&
                          !match.under &&
                          `(${bodyOdd})`}
                      </span>
                    </div>
                  </div>
                  <div className="bg-[#FFD700] text-gray-900 px-3 py-1 rounded-lg font-bold">
                    {match?.homeResult}
                  </div>
                </div>

                {/* Away Team (Betted) */}
                <div className="flex items-center justify-between w-full bg-white/70 rounded-xl p-3 border border-[#228B22]/10">
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-[#228B22] rounded-full mr-3"></div>
                    <div>
                      <span className="font-bold text-gray-800">{teamName}</span>
                      <span className="text-[#FF4500] font-bold ml-2">
                        {!match.isHomeBodyOdd &&
                          !match.overs &&
                          !match.under &&
                          `(${bodyOdd})`}
                      </span>
                    </div>
                  </div>
                  <div className="bg-[#228B22] text-white px-3 py-1 rounded-lg font-bold">
                    {match?.awayResult}
                  </div>
                </div>
              </>
            );

            return (
              <div
                key={index}
                className="bg-white/80 rounded-2xl px-4 py-3 border border-[#228B22]/20 shadow-sm"
              >
                {/* Match Date Header */}
                <div className="mb-2 pb-2 border-b border-[#228B22]/20">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <span className="w-2 h-2 bg-[#1E90FF] rounded-full mr-2"></span>
                      <span className="text-gray-700 font-semibold">{match.eventDate}</span>
                    </div>
                    <div className="text-xs text-gray-500">Match #{index + 1}</div>
                  </div>
                </div>

                {/* Game Display */}
                <div className="mb-2">
                  {displayGame}
                </div>

                {/* Bet Choice */}
                <div className="pt-3 border-t border-[#228B22]/20">
                  <div className="flex items-center justify-between">
                    <span className="text-gray-600 font-medium">Your Choice:</span>
                    <div className="bg-gradient-to-r from-[#228B22] to-emerald-600 text-white px-3 py-1 rounded-full text-sm font-bold">
                      {match?.home === true && teamName}
                      {match?.away === true && teamName}
                      {match?.overs === true && t("goalOver")}
                      {match?.under === true && t("goalUnder")}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Footer Summary */}
      <div className="relative z-10 bg-gradient-to-r from-[#228B22] via-emerald-600 to-[#1F5F1F] p-2 shadow-sm">
        <div className="bg-white/90 rounded-2xl p-2 border border-white/30">
          <div className="mb-1">
              <div className="bg-gradient-to-r from-[#FFD700] to-yellow-400 text-gray-900 text-center py-2 px-4 rounded-xl font-bold text-lg shadow-sm">
              {t("betAmount")}: {oldHistory?.amount}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="flex gap-2 items-center justify-center bg-white/70 rounded-xl px-1 py-2 border border-[#228B22]/20 text-center">
              <span className="text-gray-700 font-semibold">
                {t("profitAmount")}:
              </span>
              <span className="block font-bold text-[#228B22] text-lg">
                {profitAmount}
              </span>
            </div>
            <div className="flex gap-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-xl px-1 py-2 items-center justify-center shadow-lg">
              <span className="font-semibold">
                {t("winAmount")}:
              </span>
              <span className="block font-bold text-lg">
                {winAmount}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OldMatchesPage;
